import React from 'react';
import { Card, List, Typography } from 'antd';
import { UserType } from '../../../types/user';
import { CourseType } from '../../../types/course';
import getActions from '../actions/courseItemActions';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { isTeacher } from '../../../helpers/permissions';
const { Title, Text } = Typography;

function sortCourses(courses: Array<CourseType>) {
    if (!Array.isArray(courses)) {
        return undefined;
    }
    const mutableCourses = [...courses];
    return mutableCourses.sort((a, b) => {
        if (a.is_enrolled && !b.is_enrolled) {
            return -1;
        } else if (!a.is_enrolled && b.is_enrolled) {
            return 1;
        } else {
            return (
                new Date(b.updated_at).getTime() -
                new Date(a.updated_at).getTime()
            );
        }
    });
}

const CourseList = ({
    courses,
    user,
}: {
    courses: Array<CourseType>;
    user: UserType;
}) => {
    const { t } = useTranslation();
    const sortedCourses = sortCourses(courses);

    const getCourseTitleComponent = (course: CourseType) => {
        if (!course) {
            return <Title></Title>;
        }
        if (course?.is_enrolled || isTeacher(user)) {
            return (
                <Title level={4}>
                    <Link
                        data-cy="course-catalog-list-item-link-title"
                        to={`/app/courses/${course.id}`}
                    >
                        {course.title}
                    </Link>
                </Title>
            );
        } else {
            return (
                <Title level={4}>
                    <div data-cy="course-catalog-list-item-no-link-title">
                        {course.title}
                    </div>
                </Title>
            );
        }
    };

    return (
        <List
            bordered={false}
            data-cy={'course-catalog-list'}
            size={'large'}
            pagination={{ pageSize: 10 }}
            dataSource={sortedCourses}
            renderItem={(course: CourseType) => (
                <Card
                    data-cy={'course-list-item'}
                    style={{ marginTop: '20px' }}
                    title={getCourseTitleComponent(course)}
                    extra={getActions(course, user)}
                >
                    {course.author_name && (
                        <div style={{ marginBottom: 8 }}>
                            <Text type="secondary">
                                {t('courses.instructor')}: {course.author_name}
                            </Text>
                        </div>
                    )}
                    {course.description}
                </Card>
            )}
        />
    );
};

export default CourseList;
